export default __webpack_public_path__ + "media/images/images/icons/card-1-858be1aebb500d5a031dc9c16cf8214c.png";